import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { BookingOption } from './booking-option';
import { BookingOptionsStore } from './booking-options.store';

@Injectable()
export class BookingOptionResolver  {

    constructor(private store: BookingOptionsStore) { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<BookingOption> {
        const id = route.paramMap.get('id');
        const boid = route.paramMap.get('boid');
        return this.store.get(boid, id);
    }
}
